module.exports = __webpack_public_path__ + "static/header-logo-white.d9e7e8ac.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/header-logo-white.png
// module id = 1010
// module chunks = 2